import { CommentDto } from "../../dtos/CommentDto";
import { Modules } from "../../dtos/Modules";
import { StepDto } from "../../dtos/StepDto";
import { StepStatus } from "../../dtos/StepStatus";
import { ApiResult, apiWrapper, apiWrapperWithError } from "./ApiUtils";
import { withCalendarDates } from "./calendarDates";
import { announceGrantModulesMayHaveChanged } from "./moduleEvents";


export const getStep = async (stepId: string): Promise<ApiResult<StepDto> | null> => {
    return apiWrapperWithError<StepDto>(`api/steps/${stepId}`, 'GET', `fetching step with ID ${stepId}`);
}

export const getStepRevisionComments = async (stepId: string): Promise<ApiResult<CommentDto[]> | null> => {
    return apiWrapperWithError<CommentDto[]>(`api/steps/${stepId}/revision-comments`, 'GET', `fetching step revision comments with ID ${stepId}`);
}

export const addStepRevisionComment = async (stepId: string, notify: boolean, comment: any): Promise<ApiResult<CommentDto> | null> => {
    return apiWrapperWithError<CommentDto>(`api/steps/${stepId}/revision-comments?notify=${notify}&module=${Modules.PA}`, 'POST', `creating step revision comments with ID ${ stepId }`, comment);
}

export const updateStepRevisionComment = async (stepId: string, commentId: string, comment: any): Promise<ApiResult<CommentDto> | null> => {
    return apiWrapperWithError<CommentDto>(`api/steps/${stepId}/revision-comments/${commentId}`, 'POST', `updating step revision comments with ID ${stepId}`, comment);
}

export const deleteStepRevisionComment = async (stepId: string, commentId: string): Promise<ApiResult<CommentDto> | null> => {
    return apiWrapperWithError<CommentDto>(`api/steps/${stepId}/revision-comments/${commentId}`, 'DELETE', `deleting step revision comments with ID ${stepId}`, {});
}

export const createStep = async (stepData: Omit<StepDto, 'id'>): Promise<ApiResult<StepDto> | null> => {
    return apiWrapperWithError<StepDto>(`api/steps`, 'POST', 'creating step', withCalendarDates(stepData));
};

export const updateStep = async (stepId: string, stepData: StepDto): Promise<ApiResult<StepDto> | null> => {
    if (stepData.id !== stepId)
        console.warn(`Post ID in URL (${stepId}) differs from ID in data (${stepData.id}). Using URL ID for request.`);

    return apiWrapperWithError<StepDto>(`api/steps/${stepId}`, 'PUT', `updating step with ID ${stepId}`, withCalendarDates(stepData));
};

export const deleteStep = async (stepId: string): Promise<ApiResult<boolean> | null> => {
    return apiWrapperWithError<boolean>(`api/steps/${stepId}`, 'DELETE', `deleting step ${stepId}`);
};

export const setStepStatus = async (stepId: string, stepStatus: StepStatus): Promise<ApiResult<StepDto> | null> => {
    const result = await apiWrapperWithError<StepDto>(`api/steps/${stepId}/${stepStatus}`, 'PUT', `setting status ${stepStatus} on step with ID ${stepId}`, {});

    // Approving a subtask is what fires the trigger actions, and one of those can create a module.
    // Announce it so the grant page can pick up a module that appeared without the user doing
    // anything to it directly.
    if (stepStatus === StepStatus.APPROVED && !result?.error) {
        announceGrantModulesMayHaveChanged();
    }

    return result;
};